import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { faSearch, faCheck, faTimes, faPencilAlt, faSignature, faEraser, faKey } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt, faCalendarAlt, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Filter } from 'src/app/shared/models/filter.model';
import { User } from 'src/app/shared/models/admin-models/user.model';
import { Subscription } from 'rxjs';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { Lookup } from 'src/app/shared/models/admin-models/lookup.model';
import { BranchOfficeService } from 'src/app/shared/services/admin-services/branch-office.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RoleSendService } from 'src/app/shared/services/role-send.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.sass']
})
export class UsersComponent implements OnInit, OnDestroy {
  @ViewChild('signModal', { static: false }) private signModal;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @ViewChild('alertModal', { static: false }) private alertModal;
  faSearch = faSearch;
  faCheck = faCheck;
  faTimes = faTimes;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;
  faSignature = faSignature;
  faEraser = faEraser;
  faKey = faKey;
  faCalendarAlt = faCalendarAlt;
  faTimesCircle = faTimesCircle;

  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} });
  total: Number = null;
  addOrEditBool: Boolean = true;
  userArray: User[];
  userId: Number;
  errorTitle: String;

  signaturePadOptions = {
    'minWidth': 2,
    'canvasWidth': 735,
    'canvasHeight': 300
  };

  filterForm = new FormGroup({
    firstname: new FormControl('', []),
    lastname: new FormControl('', []),
    active: new FormControl('', [])
  })

  userForm = new FormGroup({
    code: new FormControl('', [Validators.required]),
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required]),
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirm: new FormControl('', [Validators.required]),
    userType: new FormControl('', [Validators.required]),
    active: new FormControl(true, []),
    agentMustSign: new FormControl(false, []),
    branchOfficesArr: new FormControl([], []),
    jobStarted: new FormControl('', []),
    jobEnded: new FormControl('', []),
    linkCode: new FormControl('')
  })

  changePassForm = new FormGroup({
    password: new FormControl('', [Validators.required])
  })

  dropdownSettings: IDropdownSettings = {};
  roleService: Subscription;
  roleType: String;
  constructor(private userService: UserService, private modalService: NgbModal, private branchOfficeService: BranchOfficeService, private roleSendService: RoleSendService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: false
    };
  }


  ngOnInit() {
    this.getAll();
    this.getAllBranchOffices();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
  }

  branchOffices: Lookup[] = [];
  getAllBranchOffices() {
    this.branchOfficeService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
      .subscribe(
        (res) => {
          this.branchOffices = res.data;
        }
      )
  }

  getAll() {
    this.filter.data.Filter = {}

    if (this.filterForm.value.firstname)
      this.filter.data.Filter.Firstname = this.filterForm.value.firstname;
    if (this.filterForm.value.lastname)
      this.filter.data.Filter.Lastname = this.filterForm.value.lastname;
    if (this.filterForm.value.active == '1')
      this.filter.data.Filter.Active = true
    if (this.filterForm.value.active == '0')
      this.filter.data.Filter.Active = false

    this.userService.gridView(this.filter)
      .subscribe(
        (x: any) => {
          this.userArray = x.data;
          this.total = x.total
        }
      )
    // this.userService.getTotal(this.filter)
    //   .subscribe(
    //     x => this.total = x
    //   )
  }

  userObj: User;
  openAddUserModal(modal) {
    this.userObj = new User({ UsersBranchOffices: [] })
    this.addOrEditBool = true;
    this.userForm.reset({ active: true, agentMustSign: false });
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  onItemSelect(item: any) {
    console.log(this.userForm.value.branchOfficesArr)
    this.userObj.data.UsersBranchOffices.push({ BranchOfficeID: item.id, UserID: 0 })
  }
  onDeSelectItem(item: any) {
    for (let i = 0; i < this.userObj.data.UsersBranchOffices.length; i++) {
      if (item.id == this.userObj.data.UsersBranchOffices[i].BranchOfficeID) {
        this.userObj.data.UsersBranchOffices.splice(i, 1)
      }
    }
  }
  addUser() {
    let passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if (!this.userForm.value.firstname || !this.userForm.value.lastname || !this.userForm.value.email || !this.userForm.value.mobile || !this.userForm.value.username || !this.userForm.value.password || this.userForm.value.password != this.userForm.value.confirm || !this.userForm.value.userType || !this.userForm.value.jobStarted) {
      this.errorTitle = "Niste uneli sve podatke";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!passwordRegex.test(this.userForm.value.password)) {
        this.errorTitle = "Lozinka mora da ima 1 malo slovo, 1 veliko slovo, 1 broj i 1 specijalni znak i minimalna duzina 8 karaktera";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.userObj.data.AgentCode = this.userForm.value.code;
        this.userObj.data.Firstname = this.userForm.value.firstname.toUpperCase();
        this.userObj.data.Lastname = this.userForm.value.lastname.toUpperCase();
        this.userObj.data.Email = this.userForm.value.email;
        this.userObj.data.Mobile = this.userForm.value.mobile;
        this.userObj.data.Username = this.userForm.value.username;
        this.userObj.data.Password = this.userForm.value.password;
        this.userObj.data.ConfirmPassword = this.userForm.value.confirm;
        this.userObj.data.UserType = this.userForm.value.userType;
        this.userObj.data.AgentMustSign = this.userForm.value.agentMustSign;
        this.userObj.data.Active = this.userForm.value.active;
        this.userObj.data.AgentSNOCode = this.userForm.value.linkCode;
        if (this.userForm.value.jobStarted) {
          this.userObj.data.EmploymentStarted = this.userForm.value.jobStarted.year + '-' + this.userForm.value.jobStarted.month + '-' + this.userForm.value.jobStarted.day;
        } else {
          this.userObj.data.EmploymentStarted = ''
        }

        if (this.userForm.value.jobEnded) {
          this.userObj.data.EmploymentEnded = this.userForm.value.jobEnded.year + '-' + this.userForm.value.jobEnded.month + '-' + this.userForm.value.jobEnded.day;
        } else {
          this.userObj.data.EmploymentEnded = ''
        }

        console.log(this.userObj)
        this.userService.createUser(this.userObj)
          .then(
            x => {
              this.getAll();
              this.modalService.dismissAll();
            }
          )
          .catch(
            e => {
              console.log(e)
              if (e.error == 'USERNAME_ALREADY_EXISTS') {
                this.errorTitle = 'Korisničko ime već postoji';
                this.modalService.open(this.alertModal, { centered: true })
              } else if (e.error == 'AGENT_CODE_ALREADY_EXISTS') {
                this.errorTitle = 'Kod agenta već postoji';
                this.modalService.open(this.alertModal, { centered: true })
              } else {
                this.errorTitle = e.error;
                this.modalService.open(this.alertModal, { centered: true })
              }
            }
          )
        // (x: { error: String }) => {
        //   console.log(x)
        //   this.errorTitle = x.error;
        //   this.modalService.open(this.alertModal, { centered: true })
        // }
      }
    }
  }

  openEditModal(modal, id) {
    this.userForm.reset();
    this.userObj = new User({ UsersBranchOffices: [] })
    this.addOrEditBool = false;
    this.userService.getOne(id)
      .then(
        (x: { id: Number, firstname: String, lastname: String, email: String, username: String, userType: String, active: Boolean, agentMustSign: Boolean, mobile: String, agentCode: String, employmentStarted: String, employmentEnded: String, usersBranchOffices: Array<any>, agentSNOCode: String }) => {
          console.log(x);
          this.userId = id;
          this.userForm.get('code').setValue(x.agentCode)
          this.userForm.get('firstname').setValue(x.firstname)
          this.userForm.get('lastname').setValue(x.lastname);
          this.userForm.get('email').setValue(x.email);
          this.userForm.get('mobile').setValue(x.mobile);
          this.userForm.get('username').setValue(x.username);
          this.userForm.get('userType').setValue(x.userType);
          this.userForm.get('active').setValue(x.active);
          this.userForm.get('agentMustSign').setValue(x.agentMustSign);
          this.userForm.get('linkCode').setValue(x.agentSNOCode);
          let arr = []
          if (x.usersBranchOffices) {
            for (let i = 0; i < x.usersBranchOffices.length; i++) {
              this.userObj.data.UsersBranchOffices.push({ BranchOfficeID: x.usersBranchOffices[i].branchOfficeID, UserID: 0 })
              arr.push({ id: x.usersBranchOffices[i].branchOfficeID, name: x.usersBranchOffices[i].branchOffice.name })
            }
            this.userForm.get('branchOfficesArr').setValue(arr)
          }
          if (x.employmentStarted) {
            console.log({ year: parseInt(x.employmentStarted.split('T')[0].split('-')[0]), month: parseInt(x.employmentStarted.split('T')[0].split('-')[1]), day: parseInt(x.employmentStarted.split('T')[0].split('-')[2]) })
            this.userForm.get('jobStarted').setValue({ year: parseInt(x.employmentStarted.split('T')[0].split('-')[0]), month: parseInt(x.employmentStarted.split('T')[0].split('-')[1]), day: parseInt(x.employmentStarted.split('T')[0].split('-')[2]) })
          }

          if (x.employmentEnded) {
            this.userForm.get('jobEnded').setValue({ year: parseInt(x.employmentEnded.split('T')[0].split('-')[0]), month: parseInt(x.employmentEnded.split('T')[0].split('-')[1]), day: parseInt(x.employmentEnded.split('T')[0].split('-')[2]) })
          }

          this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
        }
      )
  }
  editUser() {
    this.userObj.data.ID = this.userId;
    this.userObj.data.AgentCode = this.userForm.value.code;
    this.userObj.data.Firstname = this.userForm.value.firstname.toUpperCase();
    this.userObj.data.Lastname = this.userForm.value.lastname.toUpperCase();
    this.userObj.data.Email = this.userForm.value.email;
    this.userObj.data.Mobile = this.userForm.value.mobile;
    this.userObj.data.Username = this.userForm.value.username;
    this.userObj.data.UserType = this.userForm.value.userType;
    this.userObj.data.Active = this.userForm.value.active;
    this.userObj.data.AgentMustSign = this.userForm.value.agentMustSign;
    this.userObj.data.AgentSNOCode = this.userForm.value.linkCode;
    if (this.userForm.value.jobStarted) {
      this.userObj.data.EmploymentStarted = this.userForm.value.jobStarted.year + '-' + this.userForm.value.jobStarted.month + '-' + this.userForm.value.jobStarted.day;
    } else {
      this.userObj.data.EmploymentStarted = null
    }

    if (this.userForm.value.jobEnded) {
      this.userObj.data.EmploymentEnded = this.userForm.value.jobEnded.year + '-' + this.userForm.value.jobEnded.month + '-' + this.userForm.value.jobEnded.day;
    } else {
      this.userObj.data.EmploymentEnded = null
    }
    console.log(this.userObj)

    this.userService.editUser(this.userObj)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        },
        (e: { error: String }) => {
          console.log(e)
          if (e.error == 'USERNAME_ALREADY_EXISTS') {
            this.errorTitle = 'Korisničko ime već postoji';
            this.modalService.open(this.alertModal, { centered: true })
          } else if (e.error == 'AGENT_CODE_ALREADY_EXISTS') {
            this.errorTitle = 'Kod agenta već postoji';
            this.modalService.open(this.alertModal, { centered: true })
          } else {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        }
      )
  }

  openDeleteModal(modal, id) {
    this.userId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  deleteUser() {
    this.userService.deleteUser([this.userId])
      .then(
        x => {
          this.getAll()
          this.modalService.dismissAll()
        }
      )
  }

  openSignModal(id) {
    this.userId = id;
    this.modalService.open(this.signModal, { size: 'lg', backdrop: 'static' })

  }
  completeSigning(sign) {
    let image = sign.toDataURL()
    console.log(image)
    let user = { UserID: this.userId, Signature: image };
    console.log(user)
    this.userService.userSignature(user)
      .then(
        x => {
          console.log(x)
          this.modalService.dismissAll();
          this.getAll()
        }
      )
  }

  openModaluserUnsign(modal, id) {
    this.userId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  userUnsign(id) {
    let user = { UserID: id, Signature: '' };
    console.log(user)
    this.userService.userSignature(user)
      .then(
        x => {
          console.log(x)
          this.modalService.dismissAll();
          this.getAll()
        }
      )
  }

  openChangePasswordModal(modal, id) {
    this.userId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  changeUserPassword() {
    if (this.changePassForm.invalid) {

    } else {
      let passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      if (!passwordRegex.test(this.changePassForm.value.password)) {
        this.errorTitle = "Lozinka mora da i mora da ima 1 malo slovo, 1 veliko slovo, 1 broj i 1 specijalni znak i minimalna duzina 8 karaktera";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.userService.setNewPassword(this.userId, this.changePassForm.value.password)
          .then(
            x => {
              // this.getAll();
              this.modalService.dismissAll();
            }
          )
      }
    }
  }

  clearFilters() {
    this.filterForm.reset({ firstname: '', lastname: '', active: '' })
    this.getAll();
  }

  clearDate(num) {
    if (num == 1)
      this.userForm.get('jobStarted').setValue('');
    if (num == 2)
      this.userForm.get('jobEnded').setValue('');
  }


}
